import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod/v4";
import { CampaignDetailPage } from "@/pages/campaigns/detail";
import { campaignQueries } from "@/queries/campaigns";
import { leadStatusSchema } from "@/schemas/models/lead";

const leadsSearchSchema = z.object({
  page: z.coerce.number().min(1).catch(1).optional(),
  search: z.string().optional(),
  leadStatus: z.enum([...leadStatusSchema.options, "all"]).optional(),
  dateFrom: z.coerce.date().optional(),
  dateTo: z.coerce.date().optional(),
  leadId: z.string().optional(),
  eventId: z.string().optional(),
});

export const Route = createFileRoute("/_app/speed-to-lead/campaigns/$id")({
  validateSearch: leadsSearchSchema,
  staticData: { title: "Campaign", breadcrumb: "Campaign" },
  loader: async ({ context, params }) => {
    const campaign = await context.queryClient.ensureQueryData(
      campaignQueries.detail(params.id),
    );
    return { breadcrumb: campaign.name };
  },
  component: CampaignDetail,
});

function CampaignDetail() {
  const { id } = Route.useParams();
  const { data: campaign } = useSuspenseQuery(campaignQueries.detail(id));

  return <CampaignDetailPage campaign={campaign} />;
}
